import AboutCompanySection from '../components/about/AboutCompanySection'
import AboutMissionSection from '../components/about/AboutMissionSection'
import AboutVisionSection from '../components/about/AboutVisionSection'
import AboutCorporateInfo from '../components/about/AboutCorporateInfo'
import AboutPageHero from '../components/about/AboutPageHero'
import AboutValuesSection from '../components/about/AboutValuesSection'
import AboutWhyChooseSection from '../components/about/AboutWhyChooseSection'
import SEO from '../components/common/SEO'

function About() {
  return (
    <>
      <SEO
        title="About"
        description="Learn about Torbit Metals Private Limited, a Gujarat-based metal trading company focused on quality, reliable supply and transparent execution."
      />
      <AboutPageHero />
      <AboutCompanySection />
      <AboutMissionSection />
      <AboutVisionSection />
      <AboutCorporateInfo />
      <AboutValuesSection />
      <AboutWhyChooseSection />
    </>
  )
}

export default About
